import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesSplitDetailMain } from './modules/ui/Main';

const SplitDetailPage = (
  <SuspensePage>
    <PagesSplitDetailMain />
  </SuspensePage>
);

export default SplitDetailPage;
